import React, {useState} from "react";
import styled from "styled-components";
import {colors, mediaQueries} from "../shared/config"
import LandingImg from '../assets/LandingWithoutHeader.svg'
import MobileLandingImg from '../assets/MobileLandingPage.svg'
import MobileHeaderImg from '../assets/header.svg'
import Nav from "./Nav";


const Landing = styled("div")`
  height:100vh;
  width: 100%;
  object-fit: cover;
  background-image: url(${LandingImg});
  background-position: top;
  background-size: cover;
  position: relative;
  /* ${mediaQueries.tablet} {
    height: 65vh;
    display: none;
  } */
  ${mediaQueries.mobile} {
    height: 30vh;
    display: none;
  }

`;

const MobileLanding=styled.div`
    height:80vh;
    object-fit: fill;
    background-image: url(${MobileLandingImg});
    background-position: center;
    background-size: cover;
    position: relative;

`

export default function LandingPage(props){
    const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    console.log("props.data is", props.data);
    media.addEventListener('change', () => {
    if (media.matches !== isMobile) {
      setIsMobile(media.matches);
    }
  });
    return(
        <>
        {/* <Landing/> */}
        {isMobile && <MobileLanding/>}
        </>
    )
}